// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category[data-v-684947a8]{position:relative}.category__loader[data-v-684947a8]{background:#fff;bottom:0;left:0;opacity:.5;position:absolute;right:0;top:0;z-index:5}.category__container[data-v-684947a8]{margin-left:auto;margin-right:auto;max-width:1400px;padding-left:15px;padding-right:15px;position:relative}.category__products[data-v-684947a8]{grid-gap:20px;display:grid;grid-template-columns:repeat(auto-fill,minmax(298px,1fr))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
